import React from 'react';
import ForgotPasswordComponent from '../../landing/components/forgotPassword'
const forgotPassword = () =>{
    return(
        <>
        <ForgotPasswordComponent/>
        
        </>
    )
}

export default forgotPassword